import api from './api';
import { captureSession, assertCurrentSession } from '../utils/authSession';
import { shippingId } from './shippingDocumentService';

const fail = () => { throw new Error('Tracking review unavailable.'); };
const revision = value => typeof value === 'string' && /^[a-f\d]{64}$/.test(value);
async function request(method, path, body, input = {}) {
  const sessionBinding = input.sessionBinding || captureSession();
  if (!sessionBinding.userId || !sessionBinding.hadToken) fail();
  assertCurrentSession(sessionBinding);
  const config = { sessionBinding, signal: input.signal, timeout: 20000,
    ...(method === 'post' ? { skipAuthReplay: true } : { params: body }) };
  const response = method === 'post' ? await api.post(path, body, config) : await api.get(path, config);
  assertCurrentSession(sessionBinding);
  return response?.data?.data;
}
const reasons = {
  'More than one order matches this notification. Verify the correct order.': 'Multiple orders match',
  'The email PO differs from sent order records. Verify the correct order.': 'PO differs',
  'No unique sent-order match was verified. Check the shipping notice and order.': 'No unique sent-order match',
  'The delivery association needs verification before the shipment can be completed.': 'Delivery association needs verification',
};
const validRow = row => shippingId(row?._id) && revision(row.revision) &&
  ['review', 'would_apply'].includes(row.outcome) &&
  ((typeof row.trackingNumber === 'string' && row.trackingNumber.length <= 100) || row.trackingNumber === null) &&
  Array.isArray(row.candidates) && row.candidates.every(candidate => typeof candidate.orderId === 'string' && candidate.orderId.length <= 64) &&
  Array.isArray(row.allowedActions) && row.allowedActions.every(action => ['apply', 'dismiss'].includes(action)) &&
  typeof row.resolvedExternally === 'boolean' &&
  (!row.allowedActions.includes('apply') || (!!row.trackingNumber && !row.resolvedExternally && ['shipped', 'delivered'].includes(row.event)));
const trackingIntakeService = {
  async reviewQueue(page, input, outcome = 'review') {
    if (!['review', 'would_apply'].includes(outcome)) fail();
    const data = await request('get', '/admin/mail-intake/review-queue', { page, limit: 20, outcome }, input);
    if (!data || data.reviewValidated !== true || data.page !== page || data.limit !== 20 ||
        !Number.isSafeInteger(data.total) || data.total < 0 || !Number.isSafeInteger(data.totalPages) || data.totalPages < 1 ||
        !Array.isArray(data.data) || data.data.length > 20 || data.data.some(row => !validRow(row) || row.outcome !== outcome)) fail();
    // Only authored labels cross the render boundary; never display legacy provider reasons.
    return { ...data, data: data.data.map(row => ({ ...row,
      reason: Object.prototype.hasOwnProperty.call(reasons, row.reason) ? reasons[row.reason] : 'Notification requires verification' })) };
  },
  async decide(row, action, orderId, input) {
    if (!validRow(row) || !row.allowedActions.includes(action) ||
        (action === 'apply' && (row.resolvedExternally || typeof orderId !== 'string' || !orderId.trim() || orderId.length > 64))) fail();
    const data = await request('post', `/admin/mail-intake/${row._id}/${action}`,
      { expectedRevision: row.revision, ...(action === 'apply' ? { orderId: orderId.trim() } : { note: 'Dismissed after admin review.' }) }, input);
    if (data?.reviewActionValidated !== true || data.intakeId !== row._id || !revision(data.revision) || data.revision === row.revision ||
        data.outcome !== (action === 'apply' ? 'applied' : 'dismissed') || (action === 'apply' && data.orderId !== orderId.trim())) fail();
    return data;
  },
};
export default trackingIntakeService;
